var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHappyEmoji(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#FEFEFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9399 16C24.8999 16 15.9399 24.96 15.9399 36C15.9399 47.04 24.8999 56 35.9399 56C46.9799 56 55.9399 47.04 55.9399 36C55.9399 24.96 46.9999 16 35.9399 16ZM46.7999 44.86C44.3399 48.4 40.2999 50.5 35.9999 50.5C31.6999 50.5 27.6599 48.4 25.1999 44.86C24.7199 44.18 24.8999 43.24 25.5799 42.78C26.2599 42.3 27.1999 42.48 27.6599 43.16C29.5599 45.88 32.6799 47.52 35.9999 47.52C39.3199 47.52 42.4399 45.9 44.3399 43.16C44.8199 42.48 45.7399 42.32 46.4199 42.78C47.1199 43.24 47.2799 44.18 46.7999 44.86Z",
    fill: "#ED6E5C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyEmoji);
export default __webpack_public_path__ + "static/media/happy-emoji.c1e1f928aaf3b012f74c9ac03c119c45.svg";
export { ForwardRef as ReactComponent };